import { Action } from "./Actions";
import { Dispatcher } from "flux";

export default new Dispatcher<Action>();
